<template>
  <div class="single_con" v-if="columns.length > 0 && authority">
    <van-tabs v-model="active1" color="#1989fa" :ellipsis="false" @click="test">
      <van-tab v-if="columns.length > 1">
        <div class="tab-title" slot="title" @click="test(columns, 'total')">
          全部
        </div>
      </van-tab>
      <van-tab :title="item.text || item.className" :name="item.id" v-for="item in columns" :key="item.id">
        <van-tabs color="#1989fa" :ellipsis="false" v-model="active2" @click="test"
          v-if="item.children && item.children.length > 0">
          <van-tab v-if="item.children.length > 1">
            <div class="tab-title" slot="title" @click="test(item, 'total')">
              全部
            </div>
          </van-tab>
          <van-tab :title="item1.text || item.className" :name="item1.id" v-for="item1 in item.children"
            :key="item1.id">
            <van-tabs color="#1989fa" :ellipsis="false" @click="test" v-model="active3"
              v-if="item1.children && item1.children.length > 0">
              <van-tab v-if="item1.children.length > 1">
                <div class="tab-title" slot="title" @click="test(item1, 'total')">
                  全部
                </div>
              </van-tab>
              <van-tab :title="item2.text || item.className" :name="item2.id" v-for="item2 in item1.children"
                :key="item2.id">
                <van-tabs color="#1989fa" :ellipsis="false" @click="test" v-model="active4"
                  v-if="item2.children && item2.children.length > 0">
                  <van-tab v-if="item2.children.length > 1">
                    <div class="tab-title" slot="title" @click="test(item2, 'total')">
                      全部
                    </div>
                  </van-tab>
                  <van-tab :title="item3.text || item.className" :name="item3.id" v-for="item3 in item2.children"
                    :key="item3.id">
                    <van-tabs color="#1989fa" @click="test" :ellipsis="false" v-model="active5"
                      v-if="item3.children && item3.children.length > 0">
                      <van-tab v-if="item3.children.length > 1">
                        <div class="tab-title" slot="title" @click="test(item3, 'total')">
                          全部
                        </div>
                      </van-tab>
                      <van-tab :title="item4.text || item.className" :name="item4.id" v-for="item4 in item3.children"
                        :key="item4.id">
                        <van-tabs color="#1989fa" :ellipsis="false" v-model="active6"
                          v-if="item4.children && item4.children.length > 0">
                          <van-tab v-if="item4.children.length > 1">
                            <div class="tab-title" slot="title" @click="test(item4, 'total')">
                              全部
                            </div>
                          </van-tab>
                          <van-tab :title="item5.text || item.className" :name="item5.id"
                            v-for="item5 in item4.children" :key="item5.id">
                            <van-tabs color="#1989fa" :ellipsis="false" v-model="active7"
                              v-if="item5.children && item5.children.length > 0">
                              <van-tab v-if="item5.children.length > 1">
                                <div class="tab-title" slot="title" @click="test(item5, 'total')">
                                  全部
                                </div>
                              </van-tab>
                              <van-tab :title="item6.text || item.className" :name="item6.id"
                                v-for="item6 in item5.children" :key="item6.id">
                                <van-tabs color="#1989fa" :ellipsis="false" v-model="active8"
                                  v-if="item6.children && item6.children.length > 0">
                                  <van-tab v-if="item6.children.length > 1">
                                    <div class="tab-title" slot="title" @click="test(item6, 'total')">
                                      全部
                                    </div>
                                  </van-tab>
                                  <van-tab :title="item7.text || item.className" :name="item7.id"
                                    v-for="item7 in item6.children" :key="item7.id">
                                    <van-tabs color="#1989fa" :ellipsis="false" v-model="active9"
                                      v-if="item7.children && item7.children.length > 0">
                                      <van-tab v-if="item7.children.length > 1">
                                        <div class="tab-title" slot="title" @click="test(item7, 'total')">
                                          全部
                                        </div>
                                      </van-tab>
                                      <van-tab :name="item8.id" :title="item8.text || item.className"
                                        v-for="item8 in item7.children" :key="item8.id">
                                        <van-tabs color="#1989fa" :ellipsis="false" v-model="active10"
                                          v-if="item8.children && item8.children.length > 0">
                                          <van-tab v-if="item8.children.length > 1">
                                            <div class="tab-title" slot="title" @click="test(item8, 'total')">
                                              全部
                                            </div>
                                          </van-tab>
                                          <van-tab :title="item9.text || item.className" :name="item9.id"
                                            v-for="item9 in item8.children" :key="item9.id">
                                            <van-tabs color="#1989fa" :ellipsis="false" v-model="active11"
                                              v-if="item9.children && item9.children.length > 0">
                                              <van-tab title="全部" v-if="item9.children.length > 1">
                                                <div class="tab-title" slot="title" @click="test(item9, 'total')">
                                                  全部
                                                </div>
                                              </van-tab>
                                              <van-tab :title="item10.text || item.className" :name="item10.id"
                                                v-for="item10 in item9.children" :key="item10.id"></van-tab>
                                            </van-tabs>
                                          </van-tab>
                                        </van-tabs>
                                      </van-tab>
                                    </van-tabs>
                                  </van-tab>
                                </van-tabs>
                              </van-tab>
                            </van-tabs>
                          </van-tab>
                        </van-tabs>
                      </van-tab>
                    </van-tabs>
                  </van-tab>
                </van-tabs>
              </van-tab>
            </van-tabs>
          </van-tab>
        </van-tabs>
      </van-tab>
    </van-tabs>
    <div class="wrap">
      <div class="wrap-1">
        <div class="class-date flex flex-center">
          <van-icon name="arrow-left" @click="prevArrow" />
          <span @click="selectDate">{{ date }}</span>
          <van-icon name="arrow" @click="nextArrow" />
        </div>
        <div class="ss-info">
          <div class="ss-info-content">
            <div :class="['info-item', { acitve: infoItemClass == 1 }]" @click="selectInfoItem(1)">
              <div class="info-count">
                <span>{{ data.classNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">应到</div>
            </div>
            <div :class="['info-item', { acitve: infoItemClass == 2 }]" @click="selectInfoItem(2)">
              <div class="info-count">
                <span>{{ data.normalNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">实到</div>
            </div>
            <div :class="['info-item', { acitve: infoItemClass == 3 }]" @click="selectInfoItem(3)">
              <div class="info-count">
                <span style="color: #d21111">{{ data.absenceNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">缺勤</div>
            </div>
            <div :class="['info-item', { acitve: infoItemClass == 4 }]" @click="selectInfoItem(4)">
              <div class="info-count">
                <span>{{ data.leaveNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">请假</div>
            </div>

            <!-- 在校人数 -->
            <div :class="['info-item', { acitve: infoItemClass == 7 }]" @click="selectInfoItem(7)">
              <div class="info-count">
                <span>{{ data.inSchoolNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">在校</div>
            </div>

            <!-- 离校人数 -->
            <div :class="['info-item', { acitve: infoItemClass == 8 }]" @click="selectInfoItem(8)">
              <div class="info-count">
                <span>{{ data.notInSchoolNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">离校</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-1 wrap_list">
        <div class="title flex flex-b flex-vc">
          <span>出勤详情</span>
        </div>
        <div class="list-table">

          <!-- 顶部 -->
          <DynamicHeader :dynamicHeader="dynamicHeader"></DynamicHeader>
          <div class="list_overflow_con" v-if=" totalPage > 0 && listData && listData[dataKey].list && listData[dataKey].list.length">
            <div class="list_overflow_con_con">

            
            <DynamicBody :date="date" :totalPage="totalPage" :infoItemClass="infoItemClass" :zhiClass="getClassZhiClass()" :tableData="listData[dataKey].list" :dynamicHeader="dynamicHeader"></DynamicBody>
            </div>
          </div>

          <van-empty v-else description="暂无人员" />
        </div>
      </div>
    </div>
    <SelectTime ref="starttime" :typeTime="'选择开始时间'" @time="handleTimeStartConfirm" :minDate="minDate"
      :maxDate="new Date()" type="date" :currentDate="startMinTime" />
  </div>
  <van-empty description="暂无权限，您不是该班级的班主任，联系学校管理员将您设置为班主任后方可查看" v-else />
</template>
<script>
import SelectTime from '@/components/subScribePopup/selectTime';
import DynamicHeader from './dynamicHeader.vue';
import DynamicBody from './dynamicBody.vue';
import moment from 'moment';
export default {
  data() {
    return {
      classId: '',
      data: {},
      columns: [],
      date: moment().format('YYYY-MM-DD'),
      startMinTime: new Date(moment().format('YYYY-MM-DD')),
      minDate: new Date(2020, 1, 1),
      dataKey: 'studentClocksDTOPage',
      infoItemClass: 1,
      authority: false,
      // 标标签页默认值
      active1: '',
      active2: '',
      active3: '',
      active4: '',
      active5: '',
      active6: '',
      active7: '',
      active8: '',
      active9: '',
      active10: '',
      active11: '',
      // 分页参数
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      



    };
  },
  created() {
    this.date = this.$route.query.date;
  },
  mounted() {
    this.getClassListByTeacherId();
  },
  computed: {
    dynamicHeader: {
      get() {
        if (this.infoItemClass == 1) {
          // console.log('this.listData', this.listData)
          return this.listData ? this.listData.studentClocksDynamicHeader : ['1', '2'];
        }
        if (this.infoItemClass == 2) {
          return this.listData && this.listData.studentClocksDynamicHeader;
        }
        if (this.infoItemClass == 3) {
          return this.listData && this.listData.studentClocksDynamicHeader;
        }
        if (this.infoItemClass == 4) {
          return this.listData && this.listData.studentClocksDynamicHeader;
        }
        if (this.infoItemClass == 7) {
          return this.listData && this.listData.studentClocksDynamicHeader;
        }
        if (this.infoItemClass == 8) {
          return this.listData && this.listData.studentClocksDynamicHeader;
        }
      }
    }
  },
  methods: {
    handleChangeTab(id) {
      this.classId = id;
      this.getStudentDataByClassIdAndDate();
    },
    // tab栏选中获取出勤详情
    test(a, b) {
      if (a == 0 && !b) {
        return;
      }

      if (b == 'total' && Array.isArray(a)) {
        // 获取所有的部门
        let arr = [];
        let fn = data => {
          data.forEach(item => {
            arr.push(item.id);
            if (item.children && item.children.length) {
              fn(item.children);
            } else {
              return;
            }
          });
        };
        fn(a);
        this.classId = arr;
        this.getStudentDataByClassIdAndDate();
      } else if (b == 'total' && !Array.isArray(a) && a instanceof Object) {
        // 获取所有的部门
        let arr = [];
        let fn = data => {
          data.forEach(item => {
            arr.push(item.id);
            if (item.children && item.children.length) {
              fn(item.children);
            } else {
              return;
            }
          });
        };
        arr.push(a.id);
        fn(a.children);
        this.classId = arr;
        this.getStudentDataByClassIdAndDate();
      } else {
        let arr = [];
        let classId;

        let fn2 = data => {
          data.forEach((item, index) => {
            if (item.children && item.children.length) {
              arr.push(item.id);
              fn2(item.children);
            } else {
              arr.push(item.id);
            }
          });
        };

        let fn = data => {
          data.forEach(item => {
            if (item.id == a) {
              if (item.children && item.children.length) {
                arr.push(item.id);
                fn2(item.children);
              } else {
                return (classId = item.id);
              }
            } else {
              if (item.children && item.children.length) {
                fn(item.children);
              }
            }
          });
        };

        fn(this.columns);

        this.classId = classId || arr;
        this.getStudentDataByClassIdAndDate();
      }
    },

    selectDate() {
      this.$refs.starttime.showTimePopup = true;
    },
    selectInfoItem(index) {
      this.infoItemClass = index;
      this.getStudentDataByClassIdAndDate()
    },
    handleTimeStartConfirm(v) {
      this.date = v;
      this.getStudentDataByClassIdAndDate();
    },
    async getClassListByTeacherId() {
      const { data, code } = await this.$https.getClassListByTeacherId({
        teacherId: this.$store.state.userId
      });
      if (code !== 200) {
        return false;
      }
      // if (data[0] && data[0].id) {
      //   this.classId = data[0].id
      //   this.getStudentDataByClassIdAndDate()
      // } else {
      //   this.$toast('您不是班主任，无权限查看')
      // }
      this.setClassData(data);

      let zhi;
      let fn = data => {
        data.forEach(item => {
          if (item.id == this.$route.query.id) {
            zhi = item;
          } else {
            if (item.children && item.children.length) {
              fn(item.children);
            }
          }
        });
      };

      if (data && data.length) {
        fn(data);
      }

      if ((zhi && data.length > 0) || (this.$route.query.id == 0 && data.length > 0)) {
        this.authority = true;
        this.classId = this.$route.query.id;

        // 设置层级
        this.findPersonList();

        this.getStudentDataByClassIdAndDate();
      } else {
        this.columns = [];
      }
    },

    findPersonList() {
      let arr = [];
      function fn(data, target, result) {
        for (let i in data) {
          let item = data[i];
          if (item.id == target) {
            result.unshift(item.id);
            return true;
          }
          if (item.children && item.children.length > 0) {
            let ok = fn(item.children, target, result);
            if (ok) {
              result.unshift(item.id);
              return true;
            }
          }
        }
        return false;
      }
      fn(this.columns, this.classId, arr);

      for (let i = 0; i < arr.length; i++) {
        this[`active${i + 1}`] = arr[i];
      }
    },

    // 设置班级数据
    setClassData(data) {
      function fn(data) {
        data.forEach((item, index) => {
          if (item.className && item.className == '全部') {
            data.splice(index, 1);
          } else {
            item.text = item.label;
            item.name = item.id;
          }

          if (item.children && item.children.length) {
            fn(item.children);
          } else {
            return;
          }
        });
      }
      fn(data);
      this.columns = data;
    },


    // 获取班级列表
    getClassZhiClass() {
      let zhiClass = [];

      if (this.classId && !Array.isArray(this.classId) && this.classId > 0) {
        zhiClass[0] = this.classId;
      } else if (this.classId.length > 0 && Array.isArray(this.classId)) {
        zhiClass = this.classId;
      } else {
        // 获取全部班级
        let getIds = function (data) {
          data.forEach(item => {
            zhiClass.push(item.id);
            if (item.children && item.children.length) {
              getIds(item.children);
            } else {
              return;
            }
          });
        };

        getIds(this.columns);
      }
      return zhiClass
    },
    async getStudentDataByClassIdAndDate() {
      let zhiClass = [];
      this.totalPage = 0
      if (this.classId && !Array.isArray(this.classId) && this.classId > 0) {
        zhiClass[0] = this.classId;
      } else if (this.classId.length > 0 && Array.isArray(this.classId)) {
        zhiClass = this.classId;
      } else {
        // 获取全部班级
        let getIds = function (data) {
          data.forEach(item => {
            zhiClass.push(item.id);
            if (item.children && item.children.length) {
              getIds(item.children);
            } else {
              return;
            }
          });
        };

        getIds(this.columns);
      }
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      const res = await this.$https.getStudentDataByPersonTypeAndDateList({
        // classId: this.classId,
        organizationId: zhiClass,
        personType: 11,
        type: this.infoItemClass,
        schoolId: this.$store.state.schoolId,
        toDay: this.date
      });

      const { data, code } = await this.$https.getStudentDataByPersonTypeAndDateCount({
        // classId: this.classId,
        organizationId: zhiClass,
        personType: 11,
        schoolId: this.$store.state.schoolId,
        toDay: this.date
      });




      loading.clear();
      if (res.code !== 200) {
        return false;
      }
      this.listData = res.data[0]
      // console.log('this.listData[this.dataKey].totalPage',this.listData[this.dataKey].totalPage)
      this.totalPage = this.listData[this.dataKey].totalPage
      if (code !== 200) {
        return false;
      }
      this.data = data[0];
    },
    prevArrow() {
      this.date = moment(this.date)
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
      this.startMinTime = new Date(
        moment(this.date)
          .subtract(1, 'days')
          .format('YYYY-MM-DD')
      );
    },
    nextArrow() {
      this.date = moment(this.date)
        .add(1, 'days')
        .format('YYYY-MM-DD');
      this.startMinTime = new Date(
        moment(this.date)
          .add(1, 'days')
          .format('YYYY-MM-DD')
      );
    }
  },
  components: {
    DynamicHeader,
    DynamicBody,
    SelectTime
  },
  watch: {
    date() {
      this.getStudentDataByClassIdAndDate();
    }
  }
};
</script>

<style lang="scss" scoped>
.single_con {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  bottom: 0;
  right: 0;
}

.wrap {
  flex: 1;
  display: flex;
  background-color: #f7f7fa;
  flex-direction: column;
}

.wrap-1 {
  background: #fff;
  margin: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.wrap_list {
  flex: 1;
}

.class-date {
  padding: 15px 0 0px 0;

  span {
    margin: 0 20px;
    font-size: 15px;
    color: #1a1a1a;
  }
}

.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: '';
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}

.ss-info {
  // display: flex;
  background: #fff;
  // /* box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08); */
  border-radius: 1rem;
  padding: 1rem 0;
  overflow-x: scroll;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  // /* margin-top: 1rem; */
  // justify-content: center;
  .ss-info-content {
    display: inline-block;

    .info-item {
      display: inline-block;
      // padding: 0 5%;
      width: 80px;
      text-align: center;
      border-right: 0.06rem solid #f4f4f6;
      /* color: #454f63; */
      color: #666;

      &:last-child {
        border-right: none;
      }

      &.acitve {
        color: #37a5da;
        position: relative;

        &::before {
          content: '';
          height: 2px;
          background: #37a5da;
          width: 50%;
          position: absolute;
          bottom: -13px;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .info-count {
        font-size: 1.25rem;

        /* color: #454f63; */
        .unit {
          font-size: 0.69rem;
          margin-left: 0.4rem;
        }
      }

      .info-name {
        font-size: 0.69rem;
        margin-top: 0.3rem;
      }
    }
  }
}

.test {
  overflow-x: auto;
  display: flex;

  // width: 150%;
  .test_item {
    flex: 1 0 auto;
    float: left;
    width: 25%;
  }
}

.list-table {
  background: #fff;
  border-radius: 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;

  .list_overflow_con {
    // background-color: red;
    flex: 1;
    overflow-y: auto;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    position: relative;
    .list_overflow_con_con {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  /* margin-top: 1rem; */
  /* box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08); */

  .list-table-title {
    font-size: 0.88rem;
    color: #78849e;
    padding: 1rem;
  }
}
</style>
